import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4169d546"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "nav-section" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_o_icon = _resolveComponent("o-icon");
    const _component_o_button = _resolveComponent("o-button");
    const _component_nav_section = _resolveComponent("nav-section", true);
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
            class: _normalizeClass({ 'nav-section-control': true, 'nav-root': $props.isRoot })
        }, [
            (!$props.isRoot)
                ? (_openBlock(), _createBlock(_component_o_icon, {
                    key: 0,
                    class: _normalizeClass({ blank: $setup.filteredChildren.length == 0 }),
                    icon: $setup.filteredChildren.length == 0 ? 'circle' : $setup.open ? 'caret-down' : 'caret-right',
                    pack: $props.level > 1 && $setup.filteredChildren.length !== 0 ? 'fal' : 'fa',
                    onClick: $setup.ToggleOpen
                }, null, 8, ["class", "icon", "pack", "onClick"]))
                : _createCommentVNode("", true),
            (_openBlock(), _createBlock(_resolveDynamicComponent($setup.doNotOpen ? 'span' : 'router-link'), {
                to: { name: $props.primeRoute.name },
                class: _normalizeClass({
                    'nav-item': true,
                    'nav-is-active': $setup.isInRoute,
                    'nav-has-children': $setup.filteredChildren.length > 0,
                    'nav-is-current': $setup.isCurrent,
                    'nav-dummy': $setup.doNotOpen,
                    'nav-open': $setup.open
                }),
                onClick: $setup.SetOpenTrue
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($props.primeRoute.meta?.title), 1)
                ]),
                _: 1
            }, 8, ["to", "class", "onClick"])),
            ($setup.doNotOpen && $setup.hasFile)
                ? (_openBlock(), _createBlock(_component_o_icon, {
                    key: 1,
                    icon: "file"
                }))
                : _createCommentVNode("", true),
            ($setup.filteredChildren.length > 0 && $props.isRoot && !($setup.doNotOpen && $setup.hasFile))
                ? (_openBlock(), _createBlock(_component_o_icon, {
                    key: 2,
                    icon: $setup.open ? 'chevron-down' : 'chevron-right',
                    onClick: $setup.ToggleOpen
                }, null, 8, ["icon", "onClick"]))
                : _createCommentVNode("", true)
        ], 2),
        ($setup.open)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.$store.getters.isEditing && $setup.filteredChildren.length > 0)
                    ? (_openBlock(), _createBlock(_component_o_button, {
                        key: 0,
                        variant: "success",
                        inverted: "",
                        class: "thin",
                        size: "small",
                        onClick: $setup.OpenAddPage
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(" New page ")
                        ]),
                        _: 1
                    }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredChildren, (item) => {
                    return (_openBlock(), _createBlock(_component_nav_section, {
                        key: item.name,
                        primeRoute: item,
                        isRoot: false,
                        level: $props.level + 1,
                        isLast: $setup.IsLastChild(item),
                        onChange: _cache[0] || (_cache[0] = ($event) => ($setup.BubbleChange())),
                        onPush: _cache[1] || (_cache[1] = ($event) => ($setup.BubblePush()))
                    }, null, 8, ["primeRoute", "level", "isLast"]));
                }), 128))
            ], 64))
            : _createCommentVNode("", true)
    ], 512)), [
        [_vShow, $props.primeRoute.name]
    ]);
}
